import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course03 from "../../../course/course-03/course";
import course05 from "../../../course/course-05/course";
import lesson0313 from "../../course-03/lesson-13/lesson";
import lesson0517 from "../lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "37769a7f-fad2-4d52-814a-e26041364db5",
    course: { id: course03.id, slug: course03.slug as string, name: course03.name, publicId: course03.publicId },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0313),
    lesson: lesson0313,
  },
  {
    id: "fc1aaa9f-87c1-4c69-b7f7-19444f226343",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0517),
    lesson: lesson0517,
  },
];

export default lessonLinks;
